import HotelHitLink from './HotelHitLink.js';
import { HotelHitContentHeaderContainer, HotelHitContentHeaderLeft, HotelHitContentTitle, RatingContainer, HotelHitContentHeaderRight, HotelHitContentSubTitleContainer, HotelHitContentSubTitle } from './styles/hotelHitContentHeader.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import GlobeRating from '../../Rating/GlobeRating.js';
import WaveRating from '../../Rating/WaveRating.js';
import EsgLogo from '../../EsgLogo/EsgLogo.js';

var getSubTitles = function getSubTitles(geographical, onDistrictClick) {
  if (!geographical) {
    return null;
  }
  var district = geographical.district,
    resort = geographical.resort,
    area = geographical.area;
  var resortRenderType = resort && resort.uri ? 'a' : 'span';
  var areaRenderType = area && area.uri ? 'a' : 'span';
  return /*#__PURE__*/jsxs(HotelHitContentSubTitleContainer, {
    children: [district && (onDistrictClick ? /*#__PURE__*/jsx(HotelHitContentSubTitle, {
      type: "button",
      as: "button",
      onClick: function onClick() {
        return onDistrictClick(district.id);
      },
      children: district.name
    }) : /*#__PURE__*/jsx(HotelHitContentSubTitle, {
      type: "span",
      as: "span",
      children: district.name
    })), resort && /*#__PURE__*/jsx(HotelHitContentSubTitle, {
      type: resortRenderType === 'span' ? 'span' : null,
      as: resortRenderType,
      href: resort.uri,
      children: resort.name
    }), (area && !resort || area && resort && resort.name !== area.name) && /*#__PURE__*/jsx(HotelHitContentSubTitle, {
      type: areaRenderType === 'span' ? 'span' : null,
      as: areaRenderType,
      href: area.uri,
      children: area.name
    })]
  });
};
var HotelHitContentHeader = function HotelHitContentHeader(_ref) {
  var _ref$headerContent = _ref.headerContent,
    link = _ref$headerContent.link,
    rating = _ref$headerContent.rating,
    titleText = _ref$headerContent.titleText,
    geographical = _ref$headerContent.geographical,
    showEsg = _ref$headerContent.showEsg,
    onDistrictClick = _ref.onDistrictClick,
    href = _ref.href,
    onSelect = _ref.onSelect,
    _ref$siteId = _ref.siteId,
    siteId = _ref$siteId === void 0 ? 1 : _ref$siteId,
    _ref$isMap = _ref.isMap,
    isMap = _ref$isMap === void 0 ? false : _ref$isMap,
    lazy = _ref.lazy;
  var esg = showEsg && !isMap;
  return /*#__PURE__*/jsxs(HotelHitContentHeaderContainer, {
    children: [(href || onSelect) && /*#__PURE__*/jsx(HotelHitLink, {
      href: href,
      onSelect: onSelect
    }), /*#__PURE__*/jsxs(HotelHitContentHeaderLeft, {
      esg: esg,
      children: [/*#__PURE__*/jsx(HotelHitContentTitle, {
        esg: esg,
        children: link && link.url ? /*#__PURE__*/jsx("a", {
          href: link.url,
          target: link.target,
          children: titleText
        }) : /*#__PURE__*/jsx("span", {
          children: titleText
        })
      }), getSubTitles(geographical, onDistrictClick), !!rating && /*#__PURE__*/jsx(RatingContainer, {
        children: siteId === 18 ? /*#__PURE__*/jsx(GlobeRating, {
          rating: rating,
          responsive: true
        }) : /*#__PURE__*/jsx(WaveRating, {
          rating: rating,
          responsive: true
        })
      })]
    }), esg && /*#__PURE__*/jsx(HotelHitContentHeaderRight, {
      children: /*#__PURE__*/jsx(EsgLogo, {
        esgType: "portrait",
        lazy: lazy
      })
    })]
  });
};
HotelHitContentHeader.defaultProps = {
  headerContent: {
    link: {
      url: null,
      target: null
    },
    rating: null,
    titleText: '',
    geographical: null
  },
  onDistrictClick: null,
  href: null,
  onSelect: null,
  siteId: 1,
  isMap: false,
  lazy: false
};
var HotelHitContentHeader$1 = HotelHitContentHeader;

export { HotelHitContentHeader$1 as default };
//# sourceMappingURL=HotelHitContentHeader.js.map
